// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__20-Dw","productName":"Table_productName__12wMv"};